import { SkipNext } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

import { SkipButton } from "../../Controls.elements";

interface ButtonNextProps {
  handleClickNextVideo: () => void;
  disabled: boolean;
}

export default function ButtonNext({ handleClickNextVideo, disabled }: ButtonNextProps): React.ReactElement {
  const SkipButtonComponent = (
    <SkipButton
      disabled={disabled}
      disableFocusRipple={true}
      onClick={handleClickNextVideo}
      aria-label="Go to next slide"
      id="button_next_slide"
      sx={{
        ml: "auto",
      }}
    >
      <SkipNext />
    </SkipButton>
  );

  const tooltipTitle = "Next slide (n)";

  return disabled ? SkipButtonComponent : <Tooltip title={tooltipTitle}>{SkipButtonComponent}</Tooltip>;
}
